import { useState } from 'react';
import { TbUserEdit } from 'react-icons/tb';
import IconButton from '../../IconButton/IconButton';
import UserEditForm from '../../../Users/UserEditForm/UserEditForm';

function UserActionsCell({ params, onSuccess }) {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const handleEdit = () => {
        setIsEditModalOpen(true);
    };

    const handleClose = () => {
        setIsEditModalOpen(false);
    };

    const handleSuccess = () => {
        if (onSuccess) {
            onSuccess();
        }
        handleClose();
    };

    return (
        <>
            <IconButton 
                onClick={handleEdit} 
                variant="ghost" 
                size="small"
                title="Edit user"
            >
                <TbUserEdit />
            </IconButton>
            <UserEditForm
                isOpen={isEditModalOpen}
                onClose={handleClose}
                onSuccess={handleSuccess}
                userId={params.row.id}
                initialData={{
                    email: params.row.email,
                    code: params.row.code,
                }}
            />
        </>
    );
}

export default UserActionsCell;
